import { JobRecord, JobTypeKeys } from '@texas/api/endpoints/jobRecordsApi';
import { TFunction } from 'i18next';

export function jobTranslations(job: JobRecord, t: TFunction) {
  const type = job.type as unknown as JobTypeKeys;
  const title = t(`jobs.${type}.title`);
  return { title };
}
